<template>
  <v-footer app class="font-weight-medium" padless color="grey darken-3" dark>
    <v-col class="text-center" cols="12">
      <span class="font-weight-light">
          {{ new Date().getFullYear() }} &copy;  <strong>DSSC ICT Society </strong> | Powered by
          <a href="http://www.genixlabs.lk">
            <v-img
              :src="image"
              alt="Vuetify"
              width="100"
              height="30"
              class="ma-auto"
            />
          </a>
        </span>
    </v-col>
  </v-footer>
</template>

<script>
// Componenets
// import NoInternet_Offline from "../../components/NoInternet_Offline.vue";

// Form Validations
// Material Design Icons

/* Note: When Declaring Variables, always think about how Form Validation Rules are applied */
export default {
  // Props Received
  props: [],

  // Imported Components
  components: {},

  // Data Variables and Values
  data: () => ({
    image: require("@/assets/Genix logo 100x30 white.png")
    //
  }),

  // Custom Methods and Functions
  methods: {},
  // Life Cycle Hooks
  // beforeCreate() {},
  // created() {},
  // beforeMount() {},
  // mounted() {},
  // beforeDestroy() {},
  // destroyed() {},

  // Computed Properties
  computed: {}
};
</script>

// Custom CSS Rules and Classes
<style scoped></style>
